import { render, staticRenderFns } from "./goods2.vue?vue&type=template&id=5201677c&scoped=true"
import script from "./goods2.vue?vue&type=script&lang=js"
export * from "./goods2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201677c",
  null
  
)

export default component.exports